import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card";
import { Idea } from "@/schemas";
import { Lightbulb } from "lucide-react";

interface IdeaItemProps {
  idea: Idea;
  domainId: string;
  handleSelectIdea: (domainId: string, ideaId: string) => void;
}

export function IdeaItem({ idea, domainId, handleSelectIdea }: IdeaItemProps) {
  const label = idea.title || idea.target_keyword || "(untitled idea)";

  return (
    <HoverCard key={idea.id}>
      <HoverCardTrigger asChild>
        <div
          className="flex cursor-pointer items-center gap-2 rounded-md border border-amber-100 bg-amber-50/70 px-2.5 py-2 text-sm transition-colors hover:border-amber-200 hover:bg-amber-100/70"
          onClick={() => handleSelectIdea(domainId, idea.id)}
        >
          <Lightbulb className="h-3.5 w-3.5 flex-shrink-0 text-amber-600" />
          <span className="truncate font-medium text-amber-950">{label}</span>
          <span className="ml-auto flex-shrink-0 rounded-full bg-amber-100 px-2 py-0.5 text-[11px] uppercase tracking-wide text-amber-700">
            idea
          </span>
        </div>
      </HoverCardTrigger>
      <HoverCardContent className="w-auto p-2 text-sm">
        {idea.target_keyword
          ? `Content Idea — ${idea.target_keyword}`
          : "Content Idea"}
      </HoverCardContent>
    </HoverCard>
  );
}
